	export enum ProcessingInfoMessageType {
		Error = 1,
		Warning = 2,
		Success = 3
	}
